module.exports = __webpack_public_path__ + "static/media/20ECE14.2e426d9c.jpg";